import { MouseEvent, createContext } from 'react'

interface AccordionContextProps {
  isExpanded: (slug: string | undefined) => boolean
  toggle: (e: MouseEvent<HTMLElement>, slug: string) => void
}

const defaultState = {
  isExpanded: () => false,
  toggle: () => {}
}

const AccordionContext = createContext<AccordionContextProps>(defaultState)

export default AccordionContext
